module.exports = __webpack_public_path__ + "static/media/image-768.269181e6.webp";